import React, { useEffect, useState } from "react";
import useFontSize from '../../redux/Hooks/Kiosk/useFontSize';
import { fontSizeChangeAction } from "../../redux/Actions";
import { useDispatchKiosk } from "../../redux/Hooks/Kiosk/useDispatchKiosk";
import { useLocale } from "@davi-ai/retorik-framework";
import translation from '../../translations/subMenuItems.json';
import commonTranslation from '../../translations/common.json';
import Button from "../Common/Button";
import TextField from "./TextField";

const errorM = 'The size must be a whole number';
const countdownDefault: number = 5;

const Location = () => {
  const locale = useLocale();
  const dispatch = useDispatchKiosk();
  const fontSize = useFontSize();

  const [newSize, setNewSize] = useState<number>(fontSize === null ? 16 : fontSize);
  const [errorMessage, setErrorMessage] = useState<null | string>(null);
  const [showSave, setShowSave] = useState<boolean>(false);
  const [countdown, setCountdown] = useState<number>(countdownDefault);
  const [customTimeout, setCustomTimeout] = useState<any>();
  const [customInterval, setCustomInterval] = useState<any>();

  const launchTimeoutAndInterval = (oldSize: string) => {
    setCustomTimeout(setTimeout(() => {
        const elem = document.getElementsByTagName('html');
        elem[0].style.fontSize = oldSize;
        setShowSave(false);
      }, 5000)
    )

    setCustomInterval(setInterval(() => {
        setCountdown(countdown => countdown - 1);
      }, 1000)
    )
  }

  // Reset countdown if it reaches 0
  useEffect(() => {
    if (countdown === 0) {
      clearInterval(customInterval);
      setCountdown(countdownDefault);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown]);

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const textVal = event.currentTarget.value;
    if (textVal === '') {
      setErrorMessage(null);
      setNewSize(0);
    }
    else {
      const val = parseInt(textVal);
      if (!isNaN(val)) {
        setErrorMessage(null);
        setNewSize(val)
      } else {
        if (textVal.length > 0) {
          setErrorMessage(errorM);
        }
      }
    }
  }

  const handleApply = () => {
    setShowSave(true);
  }

  useEffect(() => {
    if (showSave) {
      const elem = document.getElementsByTagName('html');
      if(elem[0]) {
        // Get old fontSize to put it again after timer or not
        const oldSize = elem[0].style.fontSize;
        var verifiedSize = newSize;
        if (newSize > 50) {
          verifiedSize = 50;
          setNewSize(50);
        }
        if (newSize < 10) {
          verifiedSize = 10;
          setNewSize(10);
        }
        elem[0].style.fontSize = `${verifiedSize.toString()}px`;
        // Timeout to put back the fontsize after the timer if needed
        launchTimeoutAndInterval(oldSize);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSave])

  const saveFontSize = () => {
    clearTimeout(customTimeout);
    clearInterval(customInterval);
    setCountdown(countdownDefault);
    setShowSave(false);
    newSize && dispatch(fontSizeChangeAction(newSize));
  }

  return (
    <div className="w-full flex flex-col gap-4 mt-6">
      <TextField
        label={translation[locale]?.font.fontsize || translation["fr-FR"].font.fontsize}
        onChange={handleChange}
        value={newSize}
      />
      {!showSave &&
        <Button onClick={handleApply} label={commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}>
          {commonTranslation[locale]?.apply || commonTranslation["fr-FR"].apply}
        </Button>
      }
      {errorMessage && (
        <p className="italic text-yellow-300 text-center">{errorMessage}</p>
      )}
      {showSave &&
        <React.Fragment>
          {translation[locale]?.font.message1 || translation["fr-FR"].font.message1}
          {countdown}
          {translation[locale]?.font.message2 || translation["fr-FR"].font.message2}
          <Button label={commonTranslation[locale]?.save || commonTranslation["fr-FR"].save} onClick={saveFontSize}>
            {commonTranslation[locale]?.save || commonTranslation["fr-FR"].save}
          </Button>
        </React.Fragment>
      }
    </div>
  );
};

export default Location;
